module.exports = __webpack_public_path__ + "static/Perl-545383e5bf496c948892286d11bcece9.svg";